import { render, staticRenderFns } from "./DirectConversationSidebar.vue?vue&type=template&id=26707423&scoped=true"
import script from "./DirectConversationSidebar.vue?vue&type=script&lang=js"
export * from "./DirectConversationSidebar.vue?vue&type=script&lang=js"
import style0 from "./DirectConversationSidebar.vue?vue&type=style&index=0&id=26707423&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26707423",
  null
  
)

export default component.exports